module.exports = __webpack_public_path__ + "static/media/quote2.bdacb2a3.png";